import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { REACTIVE_USER, REACTIVE_USER_SUCCESS, REACTIVE_USER_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* ReactiveUser({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];
    const { clientId, programId, userId, actionType } = payload?.data;


    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/user/${userId}/status?actionType=${actionType}`,
      method: 'PUT',
      data: payload?.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: REACTIVE_USER_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: REACTIVE_USER_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: REACTIVE_USER_ERROR, payload: error });
  }
}

export function* watchReactiveUser() {
  yield takeEvery(REACTIVE_USER, ReactiveUser);
}

function* ReactiveUserSaga() {
  yield all([fork(watchReactiveUser)]);
}

export default ReactiveUserSaga;
